import { getOrthancAddress } from '../../../../../platform/core/src/utils/orthancAPI';

const orthancAddress = getOrthancAddress();

export const ohifViewerConfig = {
  // routerBasename: '/azviewer',
  routerBasename: '/',
  extensions: [],
  showStudyList: true,
  filterQueryParam: false,
  // Drops the Measurements panel and its toolbar entry. Read in App.js by
  // _initExtensions, which then never registers the extension.
  disableMeasurementPanel: true,
  servers: {
    dicomWeb: [
      {
        name: 'ORTHANC',
        wadoUriRoot: `${orthancAddress}/wado`,
        qidoRoot: `${orthancAddress}/dicom-web`,
        wadoRoot: `${orthancAddress}/dicom-web`,
        qidoSupportsIncludeField: true,
        imageRendering: 'wadors',
        thumbnailRendering: 'wadors',
        enableStudyLazyLoad: true,
        requestOptions: {
          requestFromBrowser: true,
          auth: `${process.env.ORTHANC_USERNAME || 'orthanc'}:${process.env
            .ORTHANC_PASSWORD || 'orthanc'}`,
          beforeSend: xhr => {
            xhr.setRequestHeader(
              'Authorization',
              `Basic ${btoa(
                `${process.env.ORTHANC_USERNAME || 'orthanc'}:${process.env
                  .ORTHANC_PASSWORD || 'orthanc'}`
              )}`
            );
          },
        },
      },
    ],
  },
};
